import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Label,
  Input,
} from 'reactstrap';

import UpgradePlanButton from '../UpgradePlanButton';

import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalHideFileDetails = ({ hideFileDetails, handleChange }) => {
  const intl = useIntl();

  return (
    <div className="share-hide-file-details share-setting">
      <Label for="inpHideFileDetails" className={classnames('switch', { disabled: !canUserManageShare() })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Hide file details' })}
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-hide-file-details" simple={true} />
          {userHasFeature('share-hide-file-details') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="hideFileDetails"
                id="inpHideFileDetails"
                value={true}
                checked={hideFileDetails}
                onChange={handleChange}
                disabled={!canUserManageShare()}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
    </div>
  );
};

ShareModalHideFileDetails.propTypes = {
  hideFileDetails: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalHideFileDetails;
